import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana43Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_29442)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("30"))}
        fill={getFillByLot(30, selected, lands)}
        d="M748.062 463.212L798.34 403.158L725.717 408.745L731.303 464.609L748.062 463.212Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        fill={getFillByLot(1, selected, lands)}
        d="M833.26 364.053L798.345 403.158L781.586 404.555L778.793 350.087L824.881 344.501C837.171 347.853 835.588 358.933 833.26 364.053Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        fill={getFillByLot(2, selected, lands)}
        d="M732.705 354.276L778.793 350.086L781.586 404.553L736.895 407.347L732.705 354.276Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        fill={getFillByLot(3, selected, lands)}
        d="M688.008 359.866L732.699 354.279L736.889 407.35L693.594 412.936L688.008 359.866Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        fill={getFillByLot(4, selected, lands)}
        d="M643.316 366.844L688.008 359.861L693.594 412.932L650.299 419.915L643.316 366.844Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("29"))}
        fill={getFillByLot(29, selected, lands)}
        d="M688.022 470.196L731.317 464.61L725.73 408.746L681.039 414.332L688.022 470.196Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("28"))}
        fill={getFillByLot(28, selected, lands)}
        d="M646.118 477.178L688.016 470.195L681.033 414.331L636.342 422.711L646.118 477.178Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        fill={getFillByLot(5, selected, lands)}
        d="M600.029 373.828L643.324 366.845L650.307 419.916L608.409 428.295L600.029 373.828Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("27"))}
        fill={getFillByLot(27, selected, lands)}
        d="M601.427 485.556L646.118 477.176L636.342 422.709L591.65 431.089L601.427 485.556Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        fill={getFillByLot(6, selected, lands)}
        d="M556.732 382.21L600.027 373.83L608.407 428.297L565.112 435.28L556.732 382.21Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("26"))}
        fill={getFillByLot(26, selected, lands)}
        d="M559.526 492.54L601.424 485.557L591.648 431.09L548.354 439.469L559.526 492.54Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        fill={getFillByLot(7, selected, lands)}
        d="M512.047 390.591L556.738 382.211L565.118 436.678L523.22 445.058L512.047 390.591Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("25"))}
        fill={getFillByLot(25, selected, lands)}
        d="M517.632 502.316L559.53 492.54L548.357 439.469L506.459 449.245L517.632 502.316Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        fill={getFillByLot(8, selected, lands)}
        d="M468.75 400.366L512.045 390.59L523.217 445.057L481.319 454.833L468.75 400.366Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("24"))}
        fill={getFillByLot(24, selected, lands)}
        d="M477.124 512.094L517.626 502.318L506.453 449.247L463.158 459.023L477.124 512.094Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        fill={getFillByLot(9, selected, lands)}
        d="M424.057 411.538L468.748 400.365L481.317 454.833L438.023 464.609L424.057 411.538Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("10"))}
        fill={getFillByLot(10, selected, lands)}
        d="M382.164 424.106L424.062 411.536L438.028 464.607L396.13 477.176L382.164 424.106Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("23"))}
        fill={getFillByLot(23, selected, lands)}
        d="M431.032 524.663L477.12 512.093L463.154 459.022L417.066 470.195L431.032 524.663Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("22"))}
        fill={getFillByLot(22, selected, lands)}
        d="M391.935 535.835L431.04 524.662L417.074 470.194L375.176 482.764L391.935 535.835Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("11"))}
        fill={getFillByLot(11, selected, lands)}
        d="M338.867 438.072L382.162 424.106L396.128 477.177L354.23 489.747L338.867 438.072Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("21"))}
        fill={getFillByLot(21, selected, lands)}
        d="M350.035 549.8L391.933 535.834L375.173 482.764L331.879 496.73L350.035 549.8Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("20"))}
        fill={getFillByLot(20, selected, lands)}
        d="M308.142 563.766L350.04 549.8L331.884 496.729L289.986 510.695L308.142 563.766Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("12"))}
        fill={getFillByLot(12, selected, lands)}
        d="M296.969 452.038L338.867 438.072L354.229 489.746L313.728 502.316L296.969 452.038Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("13"))}
        fill={getFillByLot(13, selected, lands)}
        d="M255.068 467.402L296.966 452.039L313.726 502.317L271.828 517.679L255.068 467.402Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("19"))}
        fill={getFillByLot(19, selected, lands)}
        d="M267.634 579.129L308.136 563.766L289.98 510.695L248.082 526.058L267.634 579.129Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("14"))}
        fill={getFillByLot(14, selected, lands)}
        d="M213.174 482.767L255.072 467.404L271.831 517.682L231.33 533.044L213.174 482.767Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("18"))}
        fill={getFillByLot(18, selected, lands)}
        d="M228.533 594.493L267.638 579.13L248.085 526.06L207.584 542.819L228.533 594.493Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("15"))}
        fill={getFillByLot(15, selected, lands)}
        d="M171.273 498.126L213.171 482.764L231.327 533.041L190.826 549.8L171.273 498.126Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("17"))}
        fill={getFillByLot(17, selected, lands)}
        d="M206.19 604.269L228.536 594.493L207.587 542.818L151.723 566.561L206.19 604.269Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("16"))}
        fill={getFillByLot(16, selected, lands)}
        d="M154.513 503.714L171.273 498.128L190.825 549.802L151.72 566.561L133.564 551.199L134.961 540.026L154.513 503.714Z"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_29442"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_29442"
            transform="matrix(0.00191567 0 0 0.00253966 -2.25945 -1.27787)"
          />
        </pattern>
        <image
          id="image0_1466_29442"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
